import Request from 'modules/request'

const handlerStatuscode = (statusCode, data) => {
  console.log(statusCode);
  switch (statusCode) {
    case 200:
      document.getElementById('data-content').innerHTML = data;
      break;
    case 401:
      console.log(statusCode);
      break;
    default:
      console.log(`O CODIGO DE RESPOSTA É: ${statusCode}`);
  }
}

export default class Department {


  getAll(url) {
    Dashboard.setCurrentPage('departments');
    const request = new Request();
    request.get(url, (request, response) => {
      handlerStatuscode(response.statusCode, response.data)
    });
  }
}
